import authSaga from "@rentiohq/shared-frontend/dist/redux/auth/auth.saga";
import contactSaga from "@rentiohq/shared-frontend/dist/redux/contact/contact.saga";
import countSaga from "@rentiohq/shared-frontend/dist/redux/count/count.saga";
import featureFlagSaga from "@rentiohq/shared-frontend/dist/redux/featureFlag/featureFlag.saga";
import paymentSaga from "@rentiohq/shared-frontend/dist/redux/payment/payment.saga";
import propertySaga from "@rentiohq/shared-frontend/dist/redux/property/property.saga";
import requirementsSaga from "@rentiohq/shared-frontend/dist/redux/requirements/requirements.saga";
import { bankAccountModule } from "@rentiohq/shared-frontend/dist/reduxV2/bankAccount";
import { all, fork } from "redux-saga/effects";

export default function* sagas() {
  yield all([
    fork(authSaga),
    fork(bankAccountModule.saga),
    fork(contactSaga),
    fork(countSaga),
    fork(featureFlagSaga),
    fork(paymentSaga),
    fork(propertySaga),
    fork(requirementsSaga),
  ]);
}
